const MIN_VISIBLE_SIZE = 100;

function dimension(value, fallback) {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : fallback;
}

/** Keep the fitted route inside the usable canvas, including small/rotated maps. */
export function calculateJourneyMapPadding({
  width, height, viewportWidth = width, viewportHeight = height, mapTop = 0, sheetTop,
}) {
  const mapWidth = dimension(width, 1024);
  const mapHeight = dimension(height, 768);
  const compact = viewportWidth <= 640 || (viewportWidth <= 960 && viewportHeight <= 560);
  const landscape = compact && viewportWidth > viewportHeight;
  const horizontalBudget = Math.max(0, mapWidth - MIN_VISIBLE_SIZE);
  const verticalBudget = Math.max(0, mapHeight - MIN_VISIBLE_SIZE);
  let left = compact ? (landscape ? 48 : 24) : 430;
  let right = compact ? (landscape ? 48 : 24) : 90;

  if (left + right > horizontalBudget) {
    const scale = horizontalBudget / (left + right);
    left *= scale;
    right *= scale;
  }

  let top = compact ? (landscape ? 90 : 150) : 110;
  let bottom = compact ? 96 : 110;
  if (compact && Number.isFinite(sheetTop)) {
    const relativeTop = sheetTop - (Number.isFinite(mapTop) ? mapTop : 0);
    if (relativeTop < mapHeight) {
      bottom = Math.max(bottom, mapHeight - Math.max(0, relativeTop) + 12);
    }
  }

  // Preserve the search/header clearance where possible, but never pass padding
  // that leaves Mapbox no canvas in which to fit the route. A nearly full sheet
  // can be collapsed by the caller and fitted again after its layout updates.
  top = Math.min(top, verticalBudget);
  bottom = Math.min(bottom, Math.max(0, verticalBudget - top));
  return { top, right, bottom, left };
}

/** Read the actual map and sheet rectangles; viewport is a fallback for mocks. */
export function getJourneyMapPadding(mapInstance) {
  const container = mapInstance?.getContainer?.();
  const rectangle = container?.getBoundingClientRect?.();
  const canvas = mapInstance?.getCanvas?.();
  const viewportWidth = typeof window === 'undefined' ? 1024
    : dimension(window.visualViewport?.width, window.innerWidth);
  const viewportHeight = typeof window === 'undefined' ? 768
    : dimension(window.visualViewport?.height, window.innerHeight);
  const frame = container?.closest?.('.map-frame');
  const sheet = frame?.querySelector('.journey-planner') ||
    (typeof document === 'undefined' ? null : document.querySelector('.journey-planner'));
  const sheetRectangle = sheet?.getBoundingClientRect?.();

  return calculateJourneyMapPadding({
    width: dimension(rectangle?.width, dimension(canvas?.clientWidth, viewportWidth)),
    height: dimension(rectangle?.height, dimension(canvas?.clientHeight, viewportHeight)),
    viewportWidth,
    viewportHeight,
    mapTop: rectangle?.top || 0,
    sheetTop: sheetRectangle?.width > 0 && sheetRectangle?.height > 0 ? sheetRectangle.top : undefined,
  });
}
